import "../static/Section5.css";
export default function Section5() {
  return (
    <section className="section5">
      <div className="section5content">
        <h3>Join Us and excel in your Music Journey</h3>
        <div className="achievements">
          <div className="marks">
            <h4>52000+</h4>
            <p className="normalText small">Hours of Live Learning</p>
          </div>
          <div className="marks">
            <h4>70+</h4>
            <p className="normalText small">Qualified Music Tutors</p>
          </div>
          <div className="marks">
            <h4>100+</h4>
            <p className="normalText small">Cities Worldwide</p>
          </div>
          <div className="marks">
            <h4>50+</h4>
            <p className="normalText small">Workshps Conducted</p>
          </div>
        </div>
      </div>
    </section>
  );
}
